module.exports = __webpack_public_path__ + "static/media/flipboard.51ebf72b.svg";